/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Latency_P99Inputs */

const en_measure_latency_p99 = /** @type {(inputs: Measure_Latency_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p99 response time`)
};

const zh_hans1_measure_latency_p99 = /** @type {(inputs: Measure_Latency_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p99 响应时间`)
};

const pt_br2_measure_latency_p99 = /** @type {(inputs: Measure_Latency_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de resposta p99`)
};

const es_measure_latency_p99 = /** @type {(inputs: Measure_Latency_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo de respuesta p99`)
};

const fr_measure_latency_p99 = /** @type {(inputs: Measure_Latency_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps de réponse p99`)
};

const de_measure_latency_p99 = /** @type {(inputs: Measure_Latency_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p99-Antwortzeit`)
};

const ru_measure_latency_p99 = /** @type {(inputs: Measure_Latency_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время ответа p99`)
};

const it_measure_latency_p99 = /** @type {(inputs: Measure_Latency_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo di risposta p99`)
};

/**
* | output |
* | --- |
* | "p99 response time" |
*
* @param {Measure_Latency_P99Inputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_latency_p99 = /** @type {((inputs?: Measure_Latency_P99Inputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Latency_P99Inputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_latency_p99(inputs)
	if (locale === "pt-BR") return pt_br2_measure_latency_p99(inputs)
	if (locale === "es") return es_measure_latency_p99(inputs)
	if (locale === "fr") return fr_measure_latency_p99(inputs)
	if (locale === "de") return de_measure_latency_p99(inputs)
	if (locale === "ru") return ru_measure_latency_p99(inputs)
	if (locale === "it") return it_measure_latency_p99(inputs)
	return en_measure_latency_p99(inputs)
});